import React from "react";
import { Button } from "react-bootstrap";

const SelectStudentTableRow = ({
	student,
	type,
	isChecked,
	toggleStudentCheck,
	removeStudent,
}) => {
	return (
		<tr>
			<td className="custom-id">{student?.username}</td>
			<td className="custom-name">{student?.name}</td>
			<td className="action-cell">
				{type === "select" ? (
					<div className="form-check">
						<input
							className="form-check-input"
							type="checkbox"
							checked={isChecked || false}
							onChange={() => toggleStudentCheck(student?.id)}
							id={`checkbox-${student?.id}`}
							style={{ width: "1.2rem", height: "1.2rem" }}
						/>
					</div>
				) : (
					<Button
						variant="danger"
						size="sm"
						onClick={() => removeStudent(student.id)}
						className="remove-student-btn"
					>
						<i className="bi bi-trash"></i>
					</Button>
				)}
			</td>
		</tr>
	);
};

export default SelectStudentTableRow;
